import { createSelector } from 'reselect';

export const getProducts = state => state.firebase.profile.products;

export const getProductsCount = createSelector(
  [getProducts],
  productList => {
    return productList.length;
  }
);



// WEBPACK FOOTER //
// ./src/store/selectors/products.js